import React, { useContext } from 'react';
import { Store } from '../Store';
import TableButtonSmall from './TableButtonSmall';

export default function TablesMobile(props) {
  const { setTableTemp, tableTemp, compartments, selectedCompartment } = props;

  const { state, dispatch: ctxDispatch } = useContext(Store);
  const { carts } = state;

  return (
    <div>
      <div className="grid">
        {carts
          .filter((c) =>
            selectedCompartment
              ? c.tableNum >= selectedCompartment.startNum &&
                c.tableNum <= selectedCompartment.endNum
              : compartments && compartments.length > 0
              ? c.tableNum <= compartments[compartments.length - 1].endNum
              : c.tableNum <= 40
          )
          .map((c) => {
            return (
              <TableButtonSmall
                isMobile={true}
                cartItems={c.cartItems}
                cart={c}
                key={c.tableNum}
                isSelected={c.tableNum === tableTemp}
                tableNum={c.tableNum}
                tableMinWitdh={'78px'}
                tableTemp={tableTemp}
                setTableTemp={setTableTemp}
                ctxDispatch={ctxDispatch}
              ></TableButtonSmall>
            );
          })}
      </div>
    </div>
  );
}
